import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SETTINGS_KEYS, environment } from '../../config/environment'
import { useSetting } from '../../hooks/useSettings'
import { capitalizeFirstLetter } from '../../utils/textUtils'
import { DocumentationDialog } from './DocumentationDialog'
import './PageHeader.scss'

interface PageHeaderProps {
  title: string
  subtitle?: string
  info?: string
  infoLink?: string
  children?: React.ReactNode
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, info, infoLink, children }) => {
  const { t } = useTranslation()
  const appTitle = useSetting(SETTINGS_KEYS.APP_TITLE, environment.appTitle)
  const [showDocsDialog, setShowDocsDialog] = useState(false)

  useEffect(() => {
    const capitalizedTitle = capitalizeFirstLetter(title)
    document.title = `${capitalizedTitle} - ${appTitle}`
  }, [title, appTitle])

  const capitalizedTitle = capitalizeFirstLetter(title)

  return (
    <>
      <div className="page-header">
        <div className="row pb-1 pb-md-1 align-items-center">
          <div className="col-md text-truncate">
            <h3 className="text-truncate align-items-center flex-wrap" style={{ lineHeight: '1.4' }}>
              <span>{capitalizedTitle}</span>
              {subtitle && (
                <span className="h6 mb-0 d-block d-md-inline fw-normal ms-md-3 text-truncate" style={{ lineHeight: '1.4' }}>
                  {subtitle}
                </span>
              )}
              {info && (
                <button
                  className="btn btn-sm btn-link text-primary p-1 ms-2 d-md-none page-header__info-btn"
                  title={t('whats_this') || "What's this?"}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault()
                    setShowDocsDialog(true)
                  }}
                >
                  <i className="bi bi-info-circle-fill"></i>
                </button>
              )}
            </h3>
            {info && (
              <small className="text-muted d-none d-md-block">
                {infoLink && (
                  <>
                    {' '}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault()
                        setShowDocsDialog(true)
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {t('read_more') + '. '}
                    </a>
                  </>
                )}
                <span dangerouslySetInnerHTML={{ __html: info }} />
              </small>
            )}
          </div>
          {children && <div className="btn-toolbar col col-md-auto gap-2">{children}</div>}
        </div>
      </div>

      {infoLink && <DocumentationDialog show={showDocsDialog} onHide={() => setShowDocsDialog(false)} docKey={infoLink} />}
    </>
  )
}

export default PageHeader
export { PageHeader }
